import { render, staticRenderFns } from "./supportUs.vue?vue&type=template&id=453d0ea6&scoped=true"
import script from "./supportUs.vue?vue&type=script&lang=js"
export * from "./supportUs.vue?vue&type=script&lang=js"
import style0 from "./supportUs.vue?vue&type=style&index=0&id=453d0ea6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453d0ea6",
  null
  
)

export default component.exports